import Vk from './Vk'
import VkAds from './VkAds'
import Yd from './Yd'

export default {
  vk: Vk,
  'vk-ads': VkAds,
  'yd': Yd,
  'yandex-business': Yd
}
